import React from "react";
import Block from "../../Block";

class CoreParagraph extends Block {
  render() {
    const { block } = this.props;
    return <div dangerouslySetInnerHTML={{ __html: block.originalContent }} />
  }
}

class CoreParagraphFactory {
  get type() {
    return "core/paragraph";
  }

  create(props) {
    return <CoreParagraph {...props} />;
  }
}

export default CoreParagraphFactory;
